import React from 'react';
import '../styles/SuccessMessage.css';

const SuccessMessage = props => (
  <div className="SuccessMessage pa3 f6 lh-copy" {...props} />
);

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/components/SuccessMessage.js